module.exports = __webpack_public_path__ + "static/media/arab20.ce83f2b4.wav";